// Vendor Feature Lock (ADO #1597) — Reports/Marketing/PO are paid upgrades for vendor accounts.
export const RESTRICTED_MEMBER_TYPES = ["Vendor", "VendorDiamond", "VendorGemstone", "Combined"];

// login is state.loginReducer. Vendors are locked unless the server explicitly grants access;
// malformed/missing featureAccess on a vendor account fails safe (locked), not open.
export const hasFeatureAccess = (login, feature) => {
  const responseData = login?.loginDetials?.responseData;
  if (!responseData) return false;

  const isRestrictedVendor = RESTRICTED_MEMBER_TYPES.includes(
    responseData.dealerMemberTypeName
  );
  if (!isRestrictedVendor) return true;

  return responseData.featureAccess?.[feature] === true;
};
